if (typeof ProductCard === 'undefined') {
  class ProductCard extends HTMLElement {
    constructor() {
      super()

      this.initialized()
    }

    initialized() {
      this.productData = this.getAttribute('data-product')
      this.buttonLabels = this.getAttribute('data-labels')
      this.inventories = this.getAttribute('data-inventories')
      this.backInStock = this.getAttribute('data-back-in-stock')
      this.quickShopModal = document.getElementById('js-quick-shop-modal')

      this.productTitle = this.querySelector('.js-product-title').innerHTML

      this.imagesContainer = this.querySelector('.js-product-card-images')
      this.images = JSON.parse(this.imagesContainer.getAttribute('data-images'))
      this.swatchImages = []

      this.swatchesContainer = this.querySelector('.js-product-card-swatches')
      if (this.swatchesContainer) {
        this.selectedSwatchName = this.querySelector('.js-active-swatch-value')
        this.swatchCurrentSwatchList = window.innerWidth > 768 ? '.ul5up' : '.ul3up'
        this.swatchList = Array.from(
          this.querySelector(`${this.swatchCurrentSwatchList}.js-product-card-swatches-list`).querySelectorAll(
            'li'
          )
        )
        this.activeSwatch = this.swatchList.find((swatch) =>
          swatch.classList.value.includes('active')
        )

        this.changeProductUrl()

        for (let i = 0; i < this.swatchList.length; i++) {
          this.swatchList[i].addEventListener(
            'mouseover',
            (e) => {
              this.previewSwatchName(
                this.swatchList[i].getAttribute('data-color')
              )
            },
            false
          )

          this.swatchList[i].addEventListener(
            'mouseout',
            (e) => {
              this.showActiveSwatchName()
            },
            false
          )

          this.swatchList[i].addEventListener(
            'click',
            (e) => {
              this.activeSwatch = this.swatchList[i]
              this.showActiveSwatchName()
              this.changeSwatch()
            },
            false
          )

          this.swatchList[i].addEventListener(
            'keypress',
            (e) => {
              if (e.key === 'Enter') {
                this.activeSwatch = this.swatchList[i]
                this.showActiveSwatchName()
                this.changeSwatch()
              }
            },
            false
          )
        }
      }

      // For Show/Hide of 3 or 5 up swatches
      const ul3up = document.getElementsByClassName('ul3up')
      const ul5up = document.getElementsByClassName('ul5up')

      let width = window.innerWidth || document.body.clientWidth
      if (width > 500) {
        Array.prototype.forEach.call(ul5up, function (e) {
          e.classList.remove('hidden')
        })
      } else if (width <= 500) {
        Array.prototype.forEach.call(ul3up, function (e) {
          e.classList.remove('hidden')
        })
      }

      this.openQuickSopButtons = Array.from(
        this.querySelectorAll('.js-open-quick-shop')
      )
      for (let i = 0; i < this.openQuickSopButtons.length; i++) {
        this.openQuickSopButtons[i].addEventListener(
          'click',
          (e) => {
            this.quickShopModal.setAttribute('data-product', this.productData)
            this.quickShopModal.setAttribute('data-labels', this.buttonLabels)
            this.quickShopModal.setAttribute(
              'data-back-in-stock',
              this.backInStock
            )
            this.quickShopModal.setAttribute(
              'data-inventories',
              this.inventories
            )
            this.quickShopModal.setAttribute('data-swatch', '')
            if (this.swatchesContainer) {
              this.quickShopModal.setAttribute(
                'data-swatch',
                this.activeSwatch.getAttribute('data-color')
              )
            }
            this.quickShopModal.initialize()
          },
          false
        )
      }

      this.renderImageCarousel()
    }

    previewSwatchName(swatchName) {
      this.selectedSwatchName.innerHTML = swatchName
    }

    showActiveSwatchName() {
      this.selectedSwatchName.innerHTML =
        this.activeSwatch.getAttribute('data-color')
    }

    changeSwatch() {
      this.swatchList.forEach((swatch) => {
        swatch.classList.remove('active')
      })

      this.activeSwatch.classList.add('active')
      this.changeSwatchImages()
      this.changeProductUrl()
    }

    changeSwatchImages() {
      const IMAGE_ALT_DELIMITER = ' $|& ';
      const activeSwatchName = this.activeSwatch.getAttribute('data-color')

      let swatchImages = this.images.filter((image) => {
        return image?.alt && image.alt.split(IMAGE_ALT_DELIMITER)[0].toLowerCase() === activeSwatchName.toLowerCase()
      })
      if (swatchImages.length) {
        this.imagesContainer.innerHTML = ''
        let imagesContents = ''
        this.imagesContainerCarousel = this.querySelector('.splide__list')
        this.imagesContainerCarousel.innerHTML = ''

        this.swatchImages = swatchImages.splice(0, 2)
        this.swatchImages.forEach((image, index) => {
          imagesContents += this.getImageContents(image, index)
          this.renderImageMobile(image)
        })
        this.imagesContainer.innerHTML = imagesContents

        this.renderImageCarousel()
        if (
          this.swatchImages.length === 1 &&
          this.querySelector('.splide__pagination')
        ) {
          this.querySelector('.splide__pagination').classList.add('invisible')
        } else if (this.swatchImages.length > 1) {
          this.querySelector('.splide__pagination').classList.remove(
            'invisible'
          )
        }
      }
    }

    getImageContents(image, index) {
      const imageUrl = getImageWithSize(image.src, 768)
      const opacityClass =
        this.swatchImages.length === 1
          ? ''
          : index === 0
          ? ' group-hover:opacity-0 '
          : ' opacity-0 group-hover:opacity-100 '
      const contents = `<img class="img object-cover absolute left-0 top-0 w-full h-full duration-300 ${opacityClass} " loading="lazy" src="${imageUrl}" title="${this.productTitle}" alt="${this.productTitle}" />`
      return contents
    }

    renderImageMobile(img) {
      const node = document.createElement('li')
      node.className = 'splide__slide h-full'
      node.innerHTML = `<img class="w-full h-full object-cover" src="${img.src}" alt="${img.alt}" />`
      this.imagesContainerCarousel.appendChild(node)
    }

    renderImageCarousel() {
      this.splideElement = this.querySelector('.splide')

      const option = {
        arrows: false,
        type: 'fade',
        rewind: true,
        classes: {
          pagination: 'splide__pagination bottom-[11px]',
          page: 'splide__pagination__page opacity-100 w-[7px] h-[7px] bg-grey-280 hover:bg-secondary-yellow hover:opacity-100 mx-[7px]',
        },
      }

      const splide = new Splide(this.splideElement, option)

      splide.mount()
      splide.refresh()

      splide.on('resize', () => {
        splide.refresh()
      })
    }

    changeProductUrl() {
      const url = this.activeSwatch.getAttribute('data-variant-url')

      const productUrlLinks = this.querySelectorAll('.js-product-url')
      for (let i = 0; i < productUrlLinks.length; i++) {
        productUrlLinks[i].setAttribute('href', url)
      }
      this.querySelector('.js-product-title').setAttribute('href', url)
    }
  }

  if (customElements.get('product-card') === undefined) {
    customElements.define('product-card', ProductCard)
  }
}
